<template>
  <div v-if="chips.length > 0" :class="wrapperClass">
    <v-chip
      v-for="(chip, index) in displayChips"
      :key="index"
      :color="chip.color"
      :class="labelClass"
      small
      :dark="chip.dark"
      class="mx-1 rounded-0"
    >
      {{ chip.label }}
    </v-chip>
    <span v-if="remainingCount > 0" class="text-caption ml-1">
      他{{ remainingCount }}件
    </span>
  </div>
  <span v-else>{{ value }}</span>
</template>

<script>
import { infoType } from '@/assets/js/objects/CDS_T_JMAInfo__c';

export default {
  name: 'JMATypeLabel',
  props: {
    value: {
      type: String,
      default: null,
    },
    fieldPath: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    labelClass: {
      type: String,
      default: null,
    },
    wrapperClass: {
      type: String,
      default: 'mx-n1',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    maxDisplay: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    infoTypeItem() {
      return infoType.find((item) => item.fieldPath === this.fieldPath);
    },
    chips() {
      if (!this.value) return [];
      
      const values = this.value.split(';').map((v) => v.trim()).filter((v) => !!v);
      const chips = [];
      
      values.forEach((value) => {
        let label = value;
        let color = this.color;
        let dark = this.dark;
        
        if (this.infoTypeItem) {
          color = this.infoTypeItem.color;
          dark = this.infoTypeItem.dark;

          // 選択肢ごとの色指定がある場合はそちらを優先
          if (this.infoTypeItem.colorMap && this.infoTypeItem.colorMap[value]) {
            color = this.infoTypeItem.colorMap[value].color;
            dark = this.infoTypeItem.colorMap[value].dark;
          }
          
          // 警戒レベル相当情報（レベル表記あり）
          if (this.infoTypeItem.levelTypes && this.infoTypeItem.levelTypes.includes(value)) {
            label = `レベル${this.infoTypeItem.levelNumber}${value}${this.infoTypeItem.levelName}`;
          }
          // 警戒レベル対象外情報（レベル表記なし）
          else if (this.infoTypeItem.traditionalTypes && this.infoTypeItem.traditionalTypes.includes(value)) {
            label = `${value}${this.infoTypeItem.levelName}`;
          }
        }
        
        chips.push({ label, color, dark });
      });
      
      return chips;
    },
    displayChips() {
      return this.chips.slice(0, this.maxDisplay);
    },
    remainingCount() {
      return Math.max(0, this.chips.length - this.maxDisplay);
    },
  },
};
</script>
